<div class="main-banner-two">
  <div class="d-table">
    <div class="d-table-cell">
      <div class="container-fluid">
        <div class="banner-content home-banner-copy">
          <p class="home-banner-kicker">Technology consulting · Automation · Delivery</p>
          <h1 class="think-forward-title" aria-label="Think. Future. Forward.">
            <span class="think-line think-line-one"><span class="think-word">Think</span><span class="think-dot" aria-hidden="true"></span></span>
            <span class="think-line think-line-two"><span class="think-word">Future</span><span class="think-dot" aria-hidden="true"></span></span>
            <span class="think-line think-line-three"><span class="think-word">Forward</span><span class="think-dot" aria-hidden="true"></span></span>
          </h1>
          <p>DotBlack helps organisations modernise systems, automate workflows, deliver complex technology programmes and access specialist IT expertise—from strategy through implementation.</p>
          <div class="home-banner-actions">
            <a class="home-banner-primary" routerLink="/contact">Discuss your requirements <span aria-hidden="true">↗</span></a>
            <a class="home-banner-secondary" href="#services">Explore our services <span aria-hidden="true">↓</span></a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="particles-js"></div>
</div>

<main class="v6-page v6-home">
  <section class="v6-home-services" id="services">
    <div class="v6-container v6-home-heading">
      <p class="v6-kicker">Our services</p>
      <h2>Capability from strategy through delivery.</h2>
      <p>Engage DotBlack for a focused requirement or an integrated technology initiative.</p>
    </div>

    <div class="v6-container v6-service-row">
      <article class="v6-service-card">
        <div class="v6-service-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" focusable="false"><path d="M17.65 6.35A7.95 7.95 0 0 0 12 4V1L7.5 5.5 12 10V7a5 5 0 1 1-4.9 6H4.05A8 8 0 1 0 17.65 6.35Z"/></svg>
        </div>
        <h2>MUF-K.Integrated</h2>
        <p>Coordinate insurers and service providers across the claims lifecycle with shared case information, work assignment, progress tracking and operational visibility.</p>
        <a class="v6-default-btn v6-card-btn" routerLink="/digital-solutions">Explore MUF-K.Integrated</a>
      </article>

      <article class="v6-service-card">
        <div class="v6-service-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" focusable="false"><path d="M19.14 12.94c.04-.31.06-.63.06-.94s-.02-.63-.07-.94l2.03-1.58-1.92-3.32-2.39.96a7.3 7.3 0 0 0-1.62-.94L14.87 3h-3.84l-.36 2.18c-.58.24-1.12.55-1.62.94l-2.39-.96-1.92 3.32 2.03 1.58c-.05.31-.07.63-.07.94s.02.63.07.94l-2.03 1.58 1.92 3.32 2.39-.96c.5.39 1.04.7 1.62.94l.36 2.18h3.84l.36-2.18c.58-.24 1.12-.55 1.62-.94l2.39.96 1.92-3.32-2.02-1.58ZM13 15.5A3.5 3.5 0 1 1 13 8a3.5 3.5 0 0 1 0 7.5Z"/></svg>
        </div>
        <h2>IT Consulting</h2>
        <p>Assess, modernise and connect applications, data and infrastructure through practical advice and implementation support.</p>
        <a class="v6-default-btn v6-card-btn" routerLink="/it-consulting">Learn More</a>
      </article>

      <article class="v6-service-card">
        <div class="v6-service-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" focusable="false"><path d="M9 21h6v-1H9v1Zm3-19a7 7 0 0 0-4.24 12.57c.71.54 1.24 1.32 1.38 2.18L9.35 18h5.3l.21-1.25c.14-.86.67-1.64 1.38-2.18A7 7 0 0 0 12 2Zm2.78 11.08c-1.04.8-1.82 1.92-2.08 3.17h-1.4c-.26-1.25-1.04-2.37-2.08-3.17A5 5 0 1 1 14.78 13.08Z"/></svg>
        </div>
        <h2>Intelligent Automation &amp; RPA</h2>
        <p>Automate repetitive work with software bots, intelligent workflows, chatbots and AI-enabled solutions designed around the process.</p>
        <a class="v6-default-btn v6-card-btn" routerLink="/rpa">Learn More</a>
      </article>

      <article class="v6-service-card">
        <div class="v6-service-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" focusable="false"><path d="M4 5h3v3H4V5Zm5 0h11v3H9V5ZM4 10.5h3v3H4v-3Zm5 0h11v3H9v-3ZM4 16h3v3H4v-3Zm5 0h11v3H9v-3Z"/></svg>
        </div>
        <h2>Programme &amp; Project Management</h2>
        <p>Bring structure, visibility and control to complex technology initiatives from planning and governance through delivery.</p>
        <a class="v6-default-btn v6-card-btn" routerLink="/project-management">Learn More</a>
      </article>

      <article class="v6-service-card">
        <div class="v6-service-icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" focusable="false"><path d="M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm6.5 1a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM9 13c-4 0-7 2-7 4.5V20h14v-2.5C16 15 13 13 9 13Zm6.5 1c-.72 0-1.4.07-2.04.2 2.02.86 3.54 2.2 4.18 3.8H22v-1.5c0-1.38-2.76-2.5-6.5-2.5Z"/></svg>
        </div>
        <h2>IT Resource Augmentation</h2>
        <p>Strengthen your delivery capacity with experienced technology professionals for projects, contracts and permanent roles.</p>
        <a class="v6-default-btn v6-card-btn" routerLink="/it-services">Learn More</a>
      </article>
    </div>
  </section>

  <section class="v6-home-value">
    <div class="v6-container">
      <div class="v6-home-heading v6-light-heading">
        <p class="v6-kicker v6-light-kicker">What you can expect</p>
        <h2>Clear thinking. Practical delivery. Sustainable capability.</h2>
      </div>
      <div class="v6-home-value-grid">
        <article><span>01</span><h3>Business first</h3><p>Technology decisions connected to clear priorities, operating needs and measurable outcomes.</p></article>
        <article><span>02</span><h3>Practical by design</h3><p>Solutions shaped around your systems, people, processes, risks and constraints.</p></article>
        <article><span>03</span><h3>Built to last</h3><p>Disciplined implementation, knowledge transfer and continuous improvement beyond go-live.</p></article>
      </div>
    </div>
  </section>

  <section class="v6-home-solutions">
    <div class="v6-container v6-home-solutions-grid">
      <div class="v6-home-heading">
        <p class="v6-kicker">Digital solutions</p>
        <h2>Claims coordination.</h2>
        <p>Explore DotBlack products designed around practical operational challenges.</p>
      </div>

      <div class="v6-home-product-list v6-single-product-list">
        <a routerLink="/digital-solutions">
          <span>Claims coordination</span>
          <h3>MUF-K.Integrated</h3>
          <p>Connect insurers and service providers across the full claims lifecycle.</p>
          <strong>Explore the platform →</strong>
        </a>
      </div>
    </div>
  </section>
</main>
